import styled from 'styled-components'

export default styled.div`
  width: 100%;
  /* height: 40px; */
  background-color: #fcebeb;

  div {
    padding: 7px 16px;
    font-family: 'ABChanel PB Regular M', Arial, sans-serif;
    font-size: 9px;
    letter-spacing: -0.3px;
    text-align: left;
    color: #ff0000;
    html[lang=tw] & {
      font-size: 12px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/styles/ItemError.js